import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import qs from "query-string";
// import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MainPageComponent from "./main.page";
import AccessRights from "../../../../configs/constants/accessRights";

function MainPageContainer() {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const qsParams = qs.parse(location.search);
  const currentSearch = qsParams.tab || "";

  const accessRights = useSelector((state) => state.session.accessRights);

  useEffect(() => {
    let tempIndex = 0;
    switch (currentSearch) {
      case "Admins":
        tempIndex = 0;
        break;
      case "Admin_Roles":
        tempIndex = 1;
        break;
      case "Company_Groups":
        tempIndex = 2;
        break;
      default:
        tempIndex = 0;
    }
    setActiveIndex(tempIndex);
  }, [currentSearch]);

  useEffect(() => {
    if (activeIndex !== null) {
      switch (activeIndex) {
        case 0:
          if (!accessRights.includes(AccessRights.ADMIN_VIEW)) {
            navigate("/admin");
          }
          break;
        case 1:
          if (!accessRights.includes(AccessRights.ADMIN_ROLE_VIEW)) {
            navigate("/admin");
          }
          break;
        case 2:
          if (!accessRights.includes(AccessRights.ADMIN_COMPANY_GROUP_VIEW)) {
            navigate("/admin");
          }
          break;
        default:
          navigate("/admin");
          break;
      }
    }
  }, [activeIndex]);

  const tabLabels = [
    {
      label: "Admins",
      accessRight: AccessRights.ADMIN_VIEW
    },
    {
      label: "Admin_Roles",
      accessRight: AccessRights.ADMIN_ROLE_VIEW
    },
    {
      label: "Company_Groups",
      accessRight: AccessRights.ADMIN_COMPANY_GROUP_VIEW
    }
  ].filter((e) => accessRights.includes(e.accessRight))
    .map((e) => e.label);

  const handleChange = (event, index) => {
    setActiveIndex(index);
    const newSearch = qs.stringify({ tab: tabLabels[index] });
    const newUrl = `${location.pathname}?${newSearch}`;
    window.history.pushState({}, '', newUrl);
  };

  return (
    <>
      <MainPageComponent
        handleChange={handleChange}
        activeIndex={activeIndex}
        tabLabels={tabLabels}
      />
    </>
  );
}

export default MainPageContainer;
